/* assets/advcoti-safe-1015.js. NEW FILE, worker COTI-SAFE-FIXES-1015 (14 to 15 Oct 2026).
   Loaded last (defer) by snippets/advcoti-lv-lander.liquid, so it only runs on the ADV-COTI page.
   18: section 05 (ADV-COTI / PREDATOR / ELF-FB20) starts open.
   21: the store wide chat bubble waits on phones until the visitor scrolls past the pitch line.
   14: lazy pictures get a srcset so phones download a size near the drawn size (Shopify CDN width param).
       Pictures in the view-through sections, the kit cards and the in the box block are left alone
       (other workers own them and their scripts swap the src).
   Never touches cart code or prices. NO EM DASHES OR EN DASHES. */
(function () {
  "use strict";
  var ROOT = document.getElementById("no-advcoti");

  /* 21 */
  var root = document.documentElement;
  function bubble() {
    var wait = window.innerWidth < 768 && (window.scrollY || window.pageYOffset || 0) < 420;
    root.classList.toggle("acsf-bubble-wait", wait);
  }
  bubble();
  window.addEventListener("scroll", bubble, { passive: true });
  window.addEventListener("resize", bubble);

  if (!ROOT) return;

  /* 18 */
  function openCompare(tries) {
    var sec = document.getElementById("viper-vs-pvs14");
    var btn = sec && sec.querySelector('button[aria-controls="viper-vs-pvs14"]');
    if (btn && btn.getAttribute("aria-expanded") === "true") return;
    /* the lander script wires this button; press it once it is wired, then check it really opened */
    if (btn && btn.getAttribute("aria-expanded") === "false") btn.click();
    if (tries > 0) setTimeout(function () {
      if (!(btn && btn.getAttribute("aria-expanded") === "true")) openCompare(tries - 1);
    }, 300);
  }

  /* 14 */
  var SKIP = '#with-without, section[aria-label="Thermal overlay modes"], #gen2-vs-gen3, #bundles, #specs, [data-acb-form]';
  var WIDTHS = [360, 540, 720, 960, 1280, 1600, 2000];
  function sizeUp() {
    var vh = window.innerHeight || 800;
    var imgs = ROOT.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.closest(SKIP) || im.hasAttribute("srcset") || im.complete && im.naturalWidth) continue;
      var src = im.getAttribute("src") || "";
      if (!/^https:\/\/cdn\.shopify\.com\/s\/files\//.test(src) || /[?&]width=/.test(src) || /\.(svg|gif)(\?|$)/i.test(src)) continue;
      var r = im.getBoundingClientRect();
      if (r.top < vh * 1.5) continue; /* already on its way in: leave it */
      var w = Math.ceil(r.width || (im.parentElement && im.parentElement.getBoundingClientRect().width) || 0);
      if (w < 40) continue;
      var sep = src.indexOf("?") >= 0 ? "&" : "?";
      im.setAttribute("sizes", w + "px");
      im.setAttribute("srcset", WIDTHS.map(function (x) { return src + sep + "width=" + x + " " + x + "w"; }).join(", "));
      im.setAttribute("data-acsf-src", src);
    }
  }
  /* if any other script swaps the src of a picture we sized, drop our srcset so the new src wins */
  try {
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        var im = m.target;
        if (im.getAttribute("data-acsf-src") && im.getAttribute("src") !== im.getAttribute("data-acsf-src")) {
          im.removeAttribute("srcset"); im.removeAttribute("sizes"); im.removeAttribute("data-acsf-src");
        }
      });
    }).observe(ROOT, { subtree: true, attributes: true, attributeFilter: ["src"] });
  } catch (e) {}

  function init() { openCompare(20); sizeUp(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
